import { mockUserRoleA } from './mockUserRoleA'
import { mockUserRoleB } from './mockUserRoleB'
import { MOCK_USER_A_ID, MOCK_USER_B_ID } from '../mockUsers'
import { UserRoles } from 'firebaseFunctions/types'

export const mockUserRoles: UserRoles = {
  [MOCK_USER_A_ID]: mockUserRoleA,
  [MOCK_USER_B_ID]: mockUserRoleB,
}
